import client from '../httpClient';

const divisionsUpdateApi = (divisionId, param) => {
  return client.put(`/divisions/${divisionId}`, JSON.stringify(param), { isShowLoading: true, isShowMessage: '組織を編集しました' });
};

export default divisionsUpdateApi;
